import writeXlsxFile from 'write-excel-file';
import { OPTION_FIELD_TYPES } from '../constants/formStudioFieldTypes';

const EXPORT_SCHEMA = [
  { column: 'Field ID', type: String, value: (row) => String(row.item_id || '') },
  { column: 'Field Name', type: String, value: (row) => row.key_name || '' },
  { column: 'Alias Name', type: String, value: (row) => row.alias_name || '' },
  { column: 'Field Type', type: String, value: (row) => row.key_type || '' },
  {
    column: 'Dropdown Value',
    type: String,
    value: (row) =>
      OPTION_FIELD_TYPES.includes(row.key_type) ? (row.key_options || []).join(', ') : '',
  },
  {
    column: 'Selected Entity',
    type: String,
    value: (row) => (row.key_type === 'ENTITY' && row?.entity?.name ? row.entity.name : ''),
  },
];

export async function exportFormFieldsToXlsx(fields, fileName = 'LeadForm') {
  const rows = Array.isArray(fields) ? fields : Object.values(fields || {});
  await writeXlsxFile(rows, {
    schema: EXPORT_SCHEMA,
    fileName: `${fileName || 'LeadForm'}.xlsx`,
  });
}
